import type { IDataViewFilters } from '@/domains/investor/components/DataView/DataViewFilters/DataViewFilters.types'
import { useDataView } from '@/domains/investor/components/DataView/DataView.composable'

export const useSignificantTransactions = async (
  filters: MaybeRefOrGetter<IDataViewFilters>,
  page: MaybeRefOrGetter<number>,
  perPage: number,
) => {
  const { useList } = useDataView()

  const { items: significantTransactions, columns: significantTransactionsColumns, total, isLoading } = await useList({
    cacheKey: 'investor-significant-transactions',
    filters,
    page,
    perPage,
    baseKey: 'investor.significantTransactions.dataView',
    linkTextKey: 'investor.significantTransactions.dataView.table.link.text',
  })

  return {
    significantTransactions,
    significantTransactionsColumns,
    total,
    isLoading,
  }
}
